var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import dayjs from 'dayjs';
import showFields from './mixins/showFields';
import queryField from './mixins/queryField';
import quickFilter from './mixins/quickFilter';
import page from './mixins/page';
import oper from './mixins/oper';

export default {
  mixins: [showFields, queryField, quickFilter, page, oper],
  created: function created() {
    if (this.funcMark !== '') {
      this.dataGridId = this.funcMark;
    } else if (this.gridMark !== '') {
      this.dataGridId = this.gridMark;
    }
    var clear = this.$route.query.clear;
    this.clearCache = clear;
    this.browsePerm = this.browse;
  },

  props: {
    funcMark: {
      type: String,
      default: ''
    },
    gridMark: {
      type: String,
      default: ''
    },
    beforeRender: {
      type: Function,
      default: null
    },
    browse: {
      type: Boolean,
      default: true
    },
    params: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    extendParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    chineseSort: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    displayQuery: {
      type: Boolean,
      default: true
    },
    rightShowTabs: {
      type: Boolean,
      default: true
    },
    customFunc: false,
    showFieldsParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    externalHeight: {
      type: [String, Number],
      default: null
    },
    // 是否开启「自定义查询」入口（prop 优先，其次读模型配置 comModelProps.enableCustomQuery）
    enableCustomQuery: {
      type: Boolean,
      default: false
    }
  },
  beforeDestroy: function beforeDestroy() {
    // 销毁时移除滚动监听，避免内存泄漏
    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener('scroll', this.handleTableScroll);
    }
    // 移除窗口缩放监听
    if (this._onGridResize) {
      window.removeEventListener('resize', this._onGridResize);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.initId();
    this.init_grid();
    // 2. 初始化：获取Table滚动容器 + 绑定滚动事件
    // this.initScrollContainer();

    // 未配置高度时列表自适应：初始计算 + 监听窗口缩放
    this.calcAutoGridHeight();
    this._onGridResize = function () {
      return _this.calcAutoGridHeight();
    };
    window.addEventListener('resize', this._onGridResize);
  },

  watch: {
    dataGridWidth: function dataGridWidth(width) {
      // 监听列表宽度变化
      this.cal_show_field_wdith(this.dataGridColumns);
    },

    gridData: {
      handler: function handler(n, o) {
        if (n && n.length > 0) {
          // this.initScrollContainer()
        }
      },

      deep: true,
      immediate: true
    }
  },
  methods: {
    // 格式化时间范围展示：合法时间格式化为 YYYY-MM-DD HH:mm:ss，否则直接展示原值
    formatTime: function formatTime(val) {
      if (val === undefined || val === null || val === '') return '';
      // 只有原始值本身包含时间分隔符（- / : T）才认为是时间格式，避免纯数字/普通字符串被 dayjs 误解析
      var s = String(val);
      if (!/[-/:T]/.test(s)) return s;
      var d = dayjs(s);
      return d.isValid() ? d.format('YYYY-MM-DD HH:mm:ss') : s;
    },
    customSearch: function customSearch() {
      var _this2 = this;

      // 自定义查询：懒加载组件（代码分割，避免打入 data-grid 主包），打开新页面
      // 传入宿主 store 供 real-api 使用，传入 mark/appId 供配置页读取
      var appId = typeof serverConfig !== 'undefined' && serverConfig && serverConfig.APP_ID || '';
      import( /* webpackChunkName: "custom-query" */'./custom-query').then(function (m) {
        m.openCustomQuery(_this2.$router, { mark: _this2.customQueryMark, store: _this2.$store, appId: appId });
      });
    },
    closeItem: function closeItem(order, index, item) {
      var _this3 = this;

      // console.log(order, index, item,'(order, index, item)',this.queryFields,',condi')

      if (item.searchValue) {
        this.$set(this.complexQueryConfig[order].fields[index], 'searchValue', '');
        if (this.queryFields && this.queryFields.length > 0) {
          this.queryFields.forEach(function (ele, eleIndex) {
            if (ele && ele.length > 0) {
              ele.forEach(function (eleChild, eleChildIndex) {
                if (item.field == eleChild.field) {
                  _this3.$set(_this3.queryFields[eleIndex][eleChildIndex], 'searchValue', '');
                }
              });
            }
          });
        }
      } else if (item.opName == 'between') {
        this.$set(this.complexQueryConfig[order].fields[index], 'start', '');
        this.$set(this.complexQueryConfig[order].fields[index], 'end', '');
      }
    },
    closeAll: function closeAll() {
      var _this4 = this;

      this.complexQueryConfig.forEach(function (ele) {
        ele.fields.forEach(function (item) {
          if (item.searchValue) {
            _this4.$set(item, 'searchValue', '');
          } else if (item.opName == 'between') {
            _this4.$set(item, 'start', '');
            _this4.$set(item, 'end', '');
          }
        });
      });
      if (this.queryFields && this.queryFields.length > 0) {
        this.queryFields.forEach(function (ele, eleIndex) {
          if (ele && ele.length > 0) {
            ele.forEach(function (eleChild, eleChildIndex) {
              _this4.$set(_this4.queryFields[eleIndex][eleChildIndex], 'searchValue', '');
            });
          }
        });
      }
    },
    confirmSearch: function confirmSearch(data) {
      this.complexQueryConfig = data;
      this.$set(this, 'complexQueryConfig', data);
      this.query_grid_data(this.pageNo, true);
    },

    // 高级查询
    resetSearch: function resetSearch() {
      this.$set(this, 'complexQueryConfig', this.complexQueryConfig && this.complexQueryConfig.length > 0 ? this.complexQueryConfig : this.comModelProps && this.comModelProps.complexQueryConfig ? JSON.parse(this.comModelProps.complexQueryConfig) : []), this.$refs.girdMoreSearch.modal = true;
    },
    initId: function initId() {
      if (this.$route.query.mark) {
        this.dataGridId = this.$route.query.mark;
      } else if (serverConfig['APP_PREFIX'] && serverConfig['APP_PREFIX'] == true && serverConfig['APP_CODE']) {
        if (!this.dataGridId.startsWith(serverConfig['APP_CODE']) && !this.dataGridId.startsWith('bsp:')) {
          this.dataGridId = serverConfig['APP_CODE'] + ':' + this.dataGridId;
        }
      }
    },
    init_grid: function init_grid() {
      if (this.funcMark !== '') {
        this.init_func_config(this.dataGridId);
      } else if (this.gridMark !== '') {
        this.showOper = false;
        this.init_grid_config(this.dataGridId);
      }
    },
    compareDateTime: function compareDateTime(condi, type) {
      if (type === 2) {
        //
        if (condi.start && condi.end) {
          if (condi.end < condi.start) {
            this.$Message['error']({
              background: true,
              content: '查询结束时间应大于开始时间'
            });
            condi.end = '';
          }
        }
      } else if (type === 1) {
        if (condi.end < condi.start) {
          if (condi.start && condi.end) {
            if (condi.end < condi.start) {
              this.$Message['error']({
                background: true,
                content: '查询开始时间应小于结束时间'
              });
              condi.start = '';
            }
          }
        }
      }
    },
    getZhcxArr: function getZhcxArr(data) {
      var _this5 = this;

      this.queryFieldsZH = [];
      if (data.length > 0 && this.complexQueryConfig.length > 0) {
        this.complexQueryConfig.forEach(function (item) {
          if (item.fields && item.fields.length > 0) {
            item.fields.forEach(function (ele) {
              data.forEach(function (eleItem) {
                if (ele.field == eleItem.name && ele.isDefault) {
                  ele = Object.assign(ele, eleItem);
                  _this5.queryFieldsZH.push(ele);
                }
              });
            });
          }
        });
        this.$nextTick(function () {
          _this5.build_query_fields(_this5.queryFieldsZH);
        });
      }
    },
    init: function init(resp) {
      var _this6 = this;

      this.returnParams = resp;
      this.comModel = resp.comModel;
      this.comModelProps = JSON.parse(resp.comModel.attachProps);
      this.$set(this, 'complexQueryConfig', this.comModelProps && this.comModelProps.complexQueryConfig ? JSON.parse(this.comModelProps.complexQueryConfig) : []), this.dataGridHeight = this.comModelProps.height;

      // this.comModelProps
      this.comModelProps.allqueryFields = resp.queryFields;
      if (this.comModelProps.labelWidth) {
        this.labelWidth = Number(this.comModelProps.labelWidth);
      }
      if (this.comModelProps.dicNames) {
        this.showDicManage = true;
      }
      this.modelShowFields = resp.showFields;

      // 根据showFieldsParams属性过滤showFields
      if (this.showFieldsParams && resp.showFields) {
        try {
          // 解析JSON对象格式的showFieldsParams
          var fieldConfig = _typeof(this.showFieldsParams) === 'object' ? this.showFieldsParams : JSON.parse(this.showFieldsParams);
          // 如果是数组格式的配置
          if (Array.isArray(fieldConfig)) {
            // 提取字段名并按orderId排序
            var sortedFields = fieldConfig.sort(function (a, b) {
              return (a.orderId || 0) - (b.orderId || 0);
            }).map(function (item) {
              return item.fieldName;
            });

            this.modelShowFields = resp.showFields.filter(function (field) {
              return sortedFields.includes(field.name);
            }).sort(function (a, b) {
              return sortedFields.indexOf(a.name) - sortedFields.indexOf(b.name);
            });
          } else {
            this.modelShowFields = resp.showFields;
          }
        } catch (e) {
          this.modelShowFields = resp.showFields;
        }
      } else {
        this.modelShowFields = resp.showFields;
      }
      // 查询条件
      if (this.comModel.isSearch && this.comModel.isSearch === '1' && resp.queryFields) {
        if (this.comModelProps.searchType) {
          this.searchType = this.comModelProps.searchType;
        }

        this.searchType === '03' ? this.getZhcxArr(resp.queryFields) : this.build_query_fields(resp.queryFields);
      }
      // 快速筛选
      if (this.comModelProps.isQuickFilter && this.comModelProps.isQuickFilter === '1') {
        // 添加可配置默认标签配置判断
        if (this.params && this.params.isDefaultTitle && resp.quickFilter && resp.quickFilter.length > 0) {
          resp.quickFilter.forEach(function (item) {
            if (item.label == _this6.params.isDefaultTitle) {
              _this6.$set(item, 'isDefault', '1');
            } else {
              _this6.$set(item, 'isDefault', '0');
            }
          });
        }
        this.build_quick_filter(resp.quickFilter);
      }
      // 分页
      if (!this.comModelProps.usePager) {
        this.pageSearch = false;
      }
      this.bulid_page(this.comModelProps.pageSizeOptions, this.comModelProps.pageSize);
      this.column = [];
      this.build_show_field();
      this.query_grid_data();
      var elementResizeDetectorMaker = require('element-resize-detector');
      // 监听元素变化
      var erd = elementResizeDetectorMaker();
      var that = this;
      if (this.dataGridId && document.getElementById(this.dataGridId)) {
        erd.listenTo(document.getElementById(this.dataGridId), function (element) {
          that.$nextTick(function () {
            that.dataGridWidth = element.offsetWidth;
            // 布局变化时重新计算自适应高度
            that.calcAutoGridHeight();
          });
        });
      }
    },
    init_grid_config: function init_grid_config(mark) {
      var _this7 = this;

      var params = {
        mark: mark
      };
      if (this.clearCache === '1') {
        params.clearCache = 'true';
      }
      this.$store.dispatch('postRequest', {
        url: '/bsp-com/com/datagrid/viewGrid',
        params: params
      }).then(function (resp) {
        _this7.dataGridLoad = true;
        if (resp.success) {
          _this7.dbType = resp.dbType;
          _this7.init(resp);
        }
      });
    },
    init_func_config: function init_func_config(mark) {
      var _this8 = this;

      var params = {
        mark: mark
      };
      if (this.clearCache === '1') {
        params.clearCache = 'true';
      }
      this.$store.dispatch('postRequest', {
        url: '/bsp-com/com/datagrid/funcGrid',
        params: params
      }).then(function (resp) {
        if (resp.success) {
          _this8.errorMsg = '';
          _this8.dataGridLoad = true;
          _this8.exportMaxCount = resp.exportMaxCount;
          var headOper = [];
          var headOperBatch = [];
          var rowOper = [];
          var rowOperBatch = [];
          var funcMark = [];
          if (resp.oper && resp.oper.length > 0) {
            resp.oper.forEach(function (item) {
              if (item.attachProps && item.attachProps !== '') {
                var props = JSON.parse(item.attachProps);
                Object.assign(item, props);
              }
              if (item.auth && item.auth !== '') {
                funcMark.push(item.mark);
              }
              if (item.dispPos === '1') {
                // 头操作
                if (item.batch) {
                  headOperBatch.push(item);
                } else {
                  headOper.push(item);
                }
              } else if (item.dispPos === '2') {
                // 行操作
                _this8.hasRowOper = true;
                if (item.batch) {
                  rowOperBatch.push(item);
                } else {
                  rowOper.push(item);
                }
              }
            });
          }

          _this8.funcAuth = funcMark;
          _this8.headOper = headOper;
          _this8.headOperBatch = headOperBatch;
          _this8.rowOper = rowOper;
          _this8.rowOperBatch = rowOperBatch;
          _this8.dbType = resp.dbType;
          _this8.init(resp);
        } else {
          _this8.loading = false;
          _this8.dataGridLoad = false;
          _this8.errorMsg = resp.msg;
        }
      });
    },
    getCustomFields: function getCustomFields(mark) {
      var _this9 = this;

      if (this.loading || this.showModal) {
        return;
      }
      this.loading = true;
      var params = {
        mark: mark
      };
      this.$store.dispatch('postRequest', {
        url: '/bsp-com/com/datagrid/getCustomShowFields',
        params: params
      }).then(function (resp) {
        _this9.loading = false;
        if (resp.success) {
          var datas = resp.data;
          var fieldList = [];
          datas.forEach(function (item, index) {
            var check = false;
            if (item.isDisplay === '1') {
              check = true;
            }
            fieldList.push({
              label: item.description,
              check: check,
              name: item.name,
              require: item.require
            });
          });
          _this9.customShowList = fieldList;
          _this9.showModal = true;
        } else {
          _this9.$Modal.warning({
            title: '温馨提示',
            content: resp.msg
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.showModal = false;
    },
    handleSet: function handleSet() {
      var _this10 = this;

      this.$Modal.confirm({
        title: '温馨提示',
        content: '是否恢复系统默认设置？',
        loading: true,
        okText: '确定',
        onOk: function onOk() {
          _this10.saveCustomReset();
        }
      });
      // resetShowFields
    },
    handleSubmit: function handleSubmit() {
      var _this11 = this;

      var arr = [];
      this.customShowList.forEach(function (item, index) {
        if (item.check) {
          arr.push(item.name + ':1');
        } else {
          arr.push(item.name + ':0');
        }
      });
      var params = {
        mark: this.dataGridId,
        fields: arr.join(',').toUpperCase()
      };
      this.$store.dispatch('postRequest', {
        url: '/bsp-com/com/datagrid/saveCustomShowFields',
        params: params
      }).then(function (resp) {
        if (resp.success) {
          _this11.showModal = false;
          _this11.init_grid();
        } else {}
      });
    },
    saveCustomReset: function saveCustomReset() {
      var _this12 = this;

      var params = {
        mark: this.dataGridId
      };
      this.$store.dispatch('postRequest', {
        url: '/bsp-com/com/datagrid/resetShowFields',
        params: params
      }).then(function (resp) {
        _this12.showModal = false;
        _this12.init_grid();
        _this12.$Modal.remove();
      });
    },
    multi_col_sort: function multi_col_sort() {
      this.getCustomFields(this.dataGridId);
      // this.showModal = true
      // console.log(this.column, '7777')
    },
    openSetPage: function openSetPage(token) {
      var modelSettingPath = '/#/setting/grid';
      if (serverConfig.MODEL_SETTING_TYPE === 'menu') {
        modelSettingPath = '/#/app/public/model';
      }
      var path = (serverConfig['BSP_URL'] ? serverConfig.BSP_URL : '') + modelSettingPath + '?appId=' + this.comModel.appId + '&id=' + this.comModel.id + '&singleSignOnToken=' + token;
      window.open(path);
    },
    openDicManage: function openDicManage() {
      this.openDicModal = true;
    },
    dragstart: function dragstart(index) {
      this.dragIndex = index;
    },
    dragenter: function dragenter(e, index) {
      e.preventDefault();
      // 避免源对象触发自身的dragenter事件
      if (this.dragIndex !== index) {
        var source = this.customShowList[this.dragIndex];
        this.customShowList.splice(this.dragIndex, 1);
        this.customShowList.splice(index, 0, source);
        // 排序变化后目标对象的索引变成源对象的索引
        this.dragIndex = index;
      }
    },
    dragover: function dragover(e, index) {
      e.preventDefault();
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/data-grid/dataGrid.js
// module id = 56
// module chunks = 0